/**
 * Whether the viewer asked for reduced motion, read synchronously.
 *
 * The AccessibilityInfo route is a promise: it answers after the first paint,
 * so a reduced-motion session still sees one transition, and its effect can
 * land after a component (or a test) has gone. On the web the preference is
 * a media query, and reading it during render answers before anything moves.
 * Without matchMedia (native, jest) the answer is "no preference".
 */
export function prefersReducedMotion(): boolean {
  try {
    const query = (globalThis as any).matchMedia?.(
      '(prefers-reduced-motion: reduce)',
    );
    return !!query?.matches;
  } catch {
    return false;
  }
}
